export const getInArr = (role, accessList = []) => accessList?.includes(role);
